import React, { useEffect, useMemo, useRef, useState } from "react";
import { Box, Typography } from "@mui/material";
import { fetchJson } from "../../api";
import Snackbar from "@mui/material/Snackbar";
import Alert from "@mui/material/Alert";

/**
 * TimelineBars
 * Props:
 * - data: { layout, blocksFlat, plan }  (come ritorna dal backend)
 */
export default function TimelineBars(props) {
  console.log("TIMELINEBARS MOUNT OK");
 // console.log("🔥 TimelineBars LIVE – props keys =", Object.keys(props || {}));

  const clamp = (v, min, max) => Math.max(min, Math.min(max, v));
  // ✅ HOOKS SEMPRE QUI (mai dopo return condizionali)
  const headerRef = useRef(null);
  const bodyRef = useRef(null);
  const [dragState, setDragState] = useState(null);
// dragState = { id, mode: "move"|"resize", startClientX, startXStart, startXEnd }

const [localEdits, setLocalEdits] = useState({});
const [saveSnack, setSaveSnack] = useState({ open: false, severity: "success", msg: "" });
const localEditsRef = useRef({});
const dragStateRef = useRef(null);

  const dayWidth = 42;
 // scala fissa (equivalente alla tua "Settimana")

const data =
  props.data ||
  {
    layout: props.layout,
    blocksFlat: props.blocks || props.blocksFlat || []
  };

const root = data?.timeline || data?.data || data || {};
const layout = root.layout || root?.timeline?.layout;
const blocksFlat = root.blocksFlat || root?.timeline?.blocksFlat || [];
const blocksById = useMemo(() => {
  const out = {};
  for (const b of (blocksFlat || [])) out[String(b.id)] = b;
  return out;
}, [blocksFlat]);


  const range =
  layout?.range ??
  { fromDay: layout?.fromDay ?? 0, toDay: layout?.toDay ?? 1 };
  const wizardPhaseOrder = useMemo(() => {
  const ep0 = data?.episodes?.[0];
  const phases = Array.isArray(ep0?.phases) ? ep0.phases : [];
  const m = new Map();
  phases.forEach((ph, i) => {
    m.set(String(ph.name || "").trim().toLowerCase(), i);
  });
  return m;
}, [data?.episodes]);

const lanes = useMemo(() => {
  return Array.isArray(layout?.lanes) ? layout.lanes : [];
}, [layout?.lanes]);


  const placements = layout?.placements || {};
  const placementsById = useMemo(() => {
  const out = {};
  for (const [k, v] of Object.entries(placements || {})) out[String(k)] = v;
  return out;
}, [placements]);

const laneIdToVisualIndex = useMemo(() => {
  const m = {};
  lanes.forEach((ln, i) => { m[String(ln.id)] = i; });
  return m;
}, [lanes]);

  const laneHeight = 60; // deve combaciare con UI attuale
  const getLaneTopPx = (laneId) => (laneIdToVisualIndex[String(laneId)] ?? 0) * laneHeight;


  const loadByDay = layout?.loadByDay || layout?.loadOverlay || [];
  const originDate =
  layout?.originDateISO ? String(layout.originDateISO)
  : layout?.originDate ? String(layout.originDate)
  : null;
  const hasValidOriginDate = Boolean(originDate);

     const fromDay = Number(range.fromDay);
  const toDay = Number(range.toDay);
  const safeRange = {
    fromDay: Number.isFinite(fromDay) ? fromDay : 0,
    toDay: Number.isFinite(toDay) ? toDay : (Number.isFinite(fromDay) ? fromDay + 1 : 1),
  };



  const originISO = useMemo(() => {
    if (!originDate) return null;
    const s = String(originDate);
    const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
    if (m) return `${m[1]}-${m[2]}-${m[3]}`;
    const d = new Date(s);
    if (Number.isNaN(d.getTime())) return null;
    const y = d.getFullYear();
    const mm = String(d.getMonth() + 1).padStart(2, "0");
    const dd = String(d.getDate()).padStart(2, "0");
    return `${y}-${mm}-${dd}`;
  }, [originDate]);
  // ✅ Working days del piano (1..7). Default 5/7
const planWorkingDays = useMemo(() => {
  const raw =
    root?.plan?.working_days ??
    root?.plan?.workingDays ??
    data?.plan?.working_days ??
    data?.plan?.workingDays;

  if (Array.isArray(raw)) return raw.map(Number).filter(Boolean);
  if (typeof raw === "string") {
    return raw
      .replace(/[{}]/g, "")
      .split(",")
      .map((v) => Number(v.trim()))
      .filter((n) => n >= 1 && n <= 7);
  }
  return [1, 2, 3, 4, 5];
}, [root, data]);


  const addDaysISO = (originISO_, dayOffset) => {
    const parts = String(originISO_ || "").slice(0, 10).split("-");
    if (parts.length !== 3) return null;

    const y = Number(parts[0]);
    const m = Number(parts[1]);
    const d = Number(parts[2]);
    const off = Number(dayOffset);

    if (![y, m, d, off].every(Number.isFinite)) return null;

    const dt = new Date(Date.UTC(y, m - 1, d));
    dt.setUTCDate(dt.getUTCDate() + off);

    if (Number.isNaN(dt.getTime())) return null;

    const yy = dt.getUTCFullYear();
    const mm = String(dt.getUTCMonth() + 1).padStart(2, "0");
    const dd = String(dt.getUTCDate()).padStart(2, "0");
    return `${yy}-${mm}-${dd}`;
  };

  
  // Date labels (semplici)
  const days = useMemo(() => {
  const arr = [];
  for (let d = safeRange.fromDay; d <= safeRange.toDay; d += 1) arr.push(d);
  return arr;
}, [safeRange.fromDay, safeRange.toDay]);

  // ✅ Scroll sync header <-> body (nessun hook condizionale)
  useEffect(() => {
    const head = headerRef.current;
    const body = bodyRef.current;
    if (!head || !body) return;

    let lock = false;

    const onBodyScroll = () => {
      if (lock) return;
      lock = true;
      head.scrollLeft = body.scrollLeft;
      lock = false;
    };

    const onHeadScroll = () => {
      if (lock) return;
      lock = true;
      body.scrollLeft = head.scrollLeft;
      lock = false;
    };

    body.addEventListener("scroll", onBodyScroll, { passive: true });
    head.addEventListener("scroll", onHeadScroll, { passive: true });

    return () => {
      body.removeEventListener("scroll", onBodyScroll);
      head.removeEventListener("scroll", onHeadScroll);
    };
  }, []);

  

  // ---- render helpers
  const totalDays = Math.max(1, (safeRange.toDay) - (safeRange.fromDay));
  const gridWidth = useMemo(() => days.length * dayWidth, [days.length, dayWidth]);
  const pxToDays = (dxPx) => Math.round(dxPx / dayWidth);
  const beginDrag = (e, mode, id, xS, xE) => {
    console.log("BEGIN DRAG", { id, mode, pointerId: e.pointerId });
  e.preventDefault();
  e.stopPropagation();

  // cattura il puntatore: evita selezione testo e "rimane appiccicato"
  if (e.currentTarget?.setPointerCapture) {
    try { e.currentTarget.setPointerCapture(e.pointerId); } catch {}
  }

 const nextDs = {
  id: String(id),
  mode,
  pointerId: e.pointerId,
  capturer: e.currentTarget,
  startClientX: e.clientX,
  startXStart: xS,
  startXEnd: xE
};
dragStateRef.current = nextDs;
setDragState(nextDs);
};


useEffect(() => {
  const onMove = (e) => {
    const ds = dragStateRef.current;
    if (!ds) return;

    const dx = e.clientX - ds.startClientX;
    const dd = pxToDays(dx);

    setLocalEdits((prev) => {
      const next = { ...(prev || {}) };
      const cur = { ...(next[ds.id] || { xStart: ds.startXStart, xEnd: ds.startXEnd }) };

      if (ds.mode === "move") {
        cur.xStart = ds.startXStart + dd;
        cur.xEnd = ds.startXEnd + dd;
      } else {
        cur.xEnd = Math.max(ds.startXStart + 1, ds.startXEnd + dd);
      }

      cur.xStart = Math.max(safeRange.fromDay, Math.min(cur.xStart, safeRange.toDay - 1));
      cur.xEnd = Math.max(cur.xStart + 1, Math.min(cur.xEnd, safeRange.toDay + 1));

      next[ds.id] = cur;
      localEditsRef.current = next;
      return next;
    });
  };

  const onUp = async () => {
    const ds = dragStateRef.current;
    if (!ds) return;

    console.log("ON UP FIRED", ds.id);
  // ✅ SGANCIA SUBITO IL DRAG (così il mouse non continua a muovere mentre la PATCH è in corso)
    const dsSnapshot = { ...ds };
    dragStateRef.current = null;
    setDragState(null);
     const dsId = String(dsSnapshot.id);

    try {
      // unlock pointer capture (se presente)
      try {
        if (dsSnapshot.capturer?.releasePointerCapture && dsSnapshot.pointerId != null) {
          dsSnapshot.capturer.releasePointerCapture(dsSnapshot.pointerId);
        }
      } catch {}

      if (!window.__postplanPatchLocks) window.__postplanPatchLocks = {};
      if (window.__postplanPatchLocks[dsId]) return;
      window.__postplanPatchLocks[dsId] = true;

      const edit = localEditsRef.current[dsSnapshot.id];
      if (edit && originISO) {
        const startDay = (dsSnapshot.mode === "resize") ? dsSnapshot.startXStart : edit.xStart;
        const endDayExcl = (dsSnapshot.mode === "resize") ? edit.xEnd : edit.xEnd;

        const startISO = addDaysISO(originISO, startDay);
        const endISO = addDaysISO(originISO, endDayExcl - 1);
        if (window.__postplanGlobalShiftLock) {
  setSaveSnack({ open: true, severity: "warning", msg: "Sto ancora salvando… riprova tra un attimo" });
  setLocalEdits({});
localEditsRef.current = {};
  return;
}
window.__postplanGlobalShiftLock = true;


console.log("PATCH PARTO", dsSnapshot.id, startISO, endISO);

// ==============================
// CALCOLO DUR_WORK (WORKING DAYS)
// ==============================
const countWorkingDaysInclusiveISO = (startISO, endISO) => {
  const startMs = Date.parse(startISO + "T00:00:00Z");
  const endMs = Date.parse(endISO + "T00:00:00Z");
  if (!Number.isFinite(startMs) || !Number.isFinite(endMs)) return 1;

  let a = startMs;
  let b = endMs;
  if (a > b) [a, b] = [b, a];

  let c = 0;
  for (let t = a; t <= b; t += 86400000) {
    const d = new Date(t);
    const dow = d.getUTCDay();          // 0..6
    const dowNorm = dow === 0 ? 7 : dow; // 1..7
    if (planWorkingDays.includes(dowNorm)) c++;
  }
  return Math.max(1, c);
};

// ==============================
// COSTRUZIONE PAYLOAD CORRETTO
// ==============================
const isResize = dsSnapshot.mode === "resize";

// ✅ durWork: delta sulle colonne (NON ricalcolare sui working days, sennò collassa nei weekend)
let durWork = undefined;

if (isResize) {
  const b0 = blocksById[String(dsSnapshot.id)];

  const origDW =
    Number(
      b0?.durWork ??
      b0?.dur_work ??
      b0?.dur_work_days ??
      b0?.duration_work ??
      b0?.durationWork
    );

  const safeOrigDW = Number.isFinite(origDW) ? origDW : Math.max(1, (dsSnapshot.startXEnd - dsSnapshot.startXStart));

  const deltaCols = Number(edit.xEnd) - Number(dsSnapshot.startXEnd); // +1 se allarghi di 1 colonna
  durWork = Math.max(1, safeOrigDW + deltaCols);
}


const payload = {
  blockId: dsSnapshot.id,
  startDate: startISO,
  endDate: endISO,
  autoShift: true,
  mode: isResize ? "resize" : "move",
  ...(isResize ? { durWork } : {}),
};

console.log("PATCH PAYLOAD >>>", JSON.stringify(payload, null, 2));
console.log("RESIZE DEBUG >>>", JSON.stringify({ isResize, mode: dsSnapshot.mode, durWork }, null, 2));



// ==============================
// PATCH (UNICA, DEFINITIVA)
// ==============================
const res = await fetch(
  `http://localhost:3001/api/postplans/blocks/${dsSnapshot.id}`,
  {
    method: "PATCH",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(payload),
  }
);



if (!res.ok) {
  console.error("PATCH fallita", res.status);
  throw new Error(`PATCH fallita ${res.status}`);
}

        setSaveSnack({ open: true, severity: "success", msg: "Salvato" });
        if (typeof props.onSaved === "function") await props.onSaved();
      }
    } catch (e) {
      console.error("Errore onUp:", e);
    } finally {
      window.__postplanGlobalShiftLock = false;
      if (window.__postplanPatchLocks && dsId) window.__postplanPatchLocks[dsId] = false;
      setLocalEdits({});
      localEditsRef.current = {};
      dragStateRef.current = null;
      setDragState(null);
    }
  };

  window.addEventListener("pointermove", onMove, { passive: true });
  window.addEventListener("pointerup", onUp, true);
  window.addEventListener("pointercancel", onUp, true);

  return () => {
    window.removeEventListener("pointermove", onMove, { passive: true });
    window.removeEventListener("pointerup", onUp, true);
    window.removeEventListener("pointercancel", onUp, true);
  };
}, [originISO, safeRange, props.onSaved]);

  useEffect(() => {
  const el = bodyRef.current;
  if (!el) return;
  // clamp scrollLeft entro bounds dopo cambio gridWidth
  const max = el.scrollWidth - el.clientWidth;
  if (el.scrollLeft > max) el.scrollLeft = Math.max(0, max);
}, [gridWidth]);



  const headerHeight = 40;

  const colorForSeverity = (sev) => {
    if (sev === "CRIT") return "rgba(255,0,0,0.10)";
    if (sev === "SAT") return "rgba(255,165,0,0.10)";
    return "transparent";
  };
  // 🎨 Color per episodio (stabile e ripetibile)
const episodeColor = (episodeIdOrNo) => {
  const palette = [
    "#4E79A7", "#F28E2B", "#E15759", "#76B7B2",
    "#59A14F", "#EDC948", "#B07AA1", "#FF9DA7",
    "#9C755F", "#BAB0AC"
  ];
  const n = Number(episodeIdOrNo);
  const idx = Number.isFinite(n) ? Math.abs(n) % palette.length : 0;
  return palette[idx];
};

// ✅ Weekend columns (sab/dom) calcolati a partire da originISO + dayIndex
const weekendDayIndexes = useMemo(() => {
  const out = [];
  if (!originISO) return out;

  for (const dayIndex of days) {
    const iso = addDaysISO(originISO, dayIndex);
    if (!iso) continue;
    const dow = new Date(iso + "T00:00:00Z").getUTCDay(); // 0=dom ... 6=sab
    const d = dow === 0 ? 7 : dow;
if (!planWorkingDays.includes(d)) out.push(dayIndex);
  }
  return out;
}, [days, originISO]);

// ✅ Split block in segments (weekend breaks). V0: usa solo sab/dom come non-working.
const splitIntoWorkingSegments = (xStart, xEnd) => {
  // xStart incluso, xEnd escluso (come già fai per width)
  const segs = [];
  if (!originISO) return [{ xS: xStart, xE: xEnd }];

  const isNonWorking = (dayIndex) => {
  const iso = addDaysISO(originISO, dayIndex);
  if (!iso) return false;
  const js = new Date(iso + "T00:00:00Z").getUTCDay(); // 0 dom .. 6 sab
  const dow = js === 0 ? 7 : js; // 1..7
  return !planWorkingDays.includes(dow);
};

  let curS = xStart;
  for (let d = xStart; d < xEnd; d += 1) {
    if (isNonWorking(d)) {
      // chiudi segmento prima del weekend
      if (curS < d) segs.push({ xS: curS, xE: d });
      curS = d + 1; // riparti dal giorno dopo
    }
  }
  if (curS < xEnd) segs.push({ xS: curS, xE: xEnd });

  // se tutto weekend (caso limite), fallback: niente segmenti
  return segs.length ? segs : [{ xS: xStart, xE: xEnd }];
};


  const formatISOFromOrigin = (originISO, dayIndex) => {
  if (!originISO && originISO !== 0) return "";

  const s = String(originISO);

  let base;
  // Caso ISO YYYY-MM-DD o YYYY-MM-DDTHH:mm...
  const m = s.match(/^(\d{4})-(\d{2})-(\d{2})/);
  if (m) {
    const y = Number(m[1]);
    const mo = Number(m[2]) - 1;
    const d = Number(m[3]);
    base = new Date(Date.UTC(y, mo, d));
  } else {
    // Fallback: stringhe tipo "Fri Feb 06" o Date.toString()
    const parsed = new Date(s);
    if (Number.isNaN(parsed.getTime())) {
      // ultimo fallback: almeno mostra qualcosa
      return `G ${dayIndex}`;
    }
    base = new Date(Date.UTC(parsed.getFullYear(), parsed.getMonth(), parsed.getDate()));
  }

  base.setUTCDate(base.getUTCDate() + Number(dayIndex));

  const weekday = base.toLocaleDateString("it-IT", { weekday: "short" }); // lun, mar...
  const dd = String(base.getUTCDate()).padStart(2, "0");
  const mm = String(base.getUTCMonth() + 1).padStart(2, "0");

  return `${weekday} ${dd}/${mm}`;
};
  // ⛔ Guard finale: se manca originDate, NON renderizziamo la timeline
  if (!hasValidOriginDate) {
    return (
      <Box sx={{ padding: 2, color: "#999" }}>
        Timeline non pronta (origine temporale mancante)
      </Box>
    );
  }

  return (
  <Box sx={{ border: "1px solid rgba(0,0,0,0.12)", borderRadius: 2, overflow: "hidden", background: "#fff" }}>
    {/* UNICO VIEWPORT SCROLLABILE */}
    <Box
      ref={bodyRef}
      sx={{
        height: 520,
        overflow: "auto",
        position: "relative"
      }}
    >
      {/* HEADER sticky top (dentro viewport) */}
      <Box
        sx={{
          position: "sticky",
          top: 0,
          zIndex: 50,
          display: "flex",
          borderBottom: "1px solid rgba(0,0,0,0.10)",
          background: "#f2f2f2"
        }}
      >
        {/* cella vuota sticky-left (angolo) */}
        <Box
          sx={{
            position: "sticky",
            left: 0,
            zIndex: 60,
            width: 240,
            flex: "0 0 auto",
            borderRight: "1px solid rgba(0,0,0,0.12)",
            background: "#d9d9d9"
          }}
        />
        {/* giorni */}
        <Box sx={{ width: gridWidth, display: "flex" }}>
          {days.map((day) => (
            <Box
              key={day}
              sx={{
              width: dayWidth,
              flex: "0 0 auto",
              px: 0.75,                 // <-- prima era 0.5: un filo più aria
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              borderRight: "1px solid rgba(0,0,0,0.06)",
            }}

            >
              {(() => {
  const s = formatISOFromOrigin(originDate, day); // es: "lun 22/01"
  const [wd, dm] = s.split(" ");
  return (
    <Box sx={{ textAlign: "center", lineHeight: 1.05 }}>
      <Typography variant="caption" sx={{ opacity: 0.85, fontWeight: 700, display: "block" }}>
        {wd || ""}
      </Typography>
      <Typography variant="caption" sx={{ opacity: 0.75, fontWeight: 600, display: "block" }}>
        {dm || ""}
      </Typography>
    </Box>
  );
})()}

            </Box>
          ))}
        </Box>
      </Box>

      {/* BODY (labels sticky-left + griglia) */}
<Box sx={{ display: "flex" }}>
  {/* Colonna sticky-left */}
  <Box
    sx={{
      position: "sticky",
      left: 0,
      zIndex: 40,
      width: 240,
      flex: "0 0 auto",
      borderRight: "1px solid rgba(0,0,0,0.12)",
      background: "#d9d9d9"
    }}
  >
    {lanes.map((ln) => (
      <Box
        key={ln.id}
        sx={{
          height: laneHeight,
          display: "flex",
          alignItems: "center",
          px: 1,
          borderBottom: "1px solid rgba(0,0,0,0.08)"
        }}
      >
        {(() => {
  const visualLaneIndex = laneIdToVisualIndex[String(ln.id)];

  const laneBlocks = blocksFlat.filter((b) => {
    const p = placementsById[String(b.id)];
    return p && p.laneIndex === visualLaneIndex;
  });

  // preferisci un blocco che abbia davvero il nome
  const sampleBlock =
    laneBlocks.find((b) => (b.lineLabel || "").trim()) ||
    laneBlocks[0] ||
    null;

  const phaseName = sampleBlock?.phaseName || ln.label || "";
  const name = (sampleBlock?.lineLabel || "").trim();

  const text = name ? `${phaseName} — ${name}` : phaseName;

  return (
    <Typography
  variant="body2"
  sx={{
    fontWeight: 700,
    whiteSpace: "normal",     // ✅ permette a capo
    overflow: "hidden",
    display: "-webkit-box",
    WebkitLineClamp: 2,       // ✅ max 2 righe
    WebkitBoxOrient: "vertical",
    lineHeight: 1.15,
  }}
>
  {text}
</Typography>
  );
})()}
      </Box>
    ))}
  </Box>

  {/* Griglia */}
  <Box sx={{ width: gridWidth, position: "relative" }}>
    {/* overlay carico */}
    <Box sx={{ position: "absolute", top: 0, left: 0, right: 0, bottom: 0, pointerEvents: "none" }}>
      {weekendDayIndexes.map((dayIndex) => {
        const x = (dayIndex - safeRange.fromDay) * dayWidth;
        return (
          <Box
            key={dayIndex}
            sx={{
              position: "absolute",
              top: 0,
              left: x,
              width: dayWidth,
              height: lanes.length * laneHeight,
              bgcolor: "rgba(255, 193, 7, 0.08)"
            }}
          />
        );
      })}
    </Box>

          {/* righe */}
          {lanes.map((ln) => (
            <Box
              key={ln.id}
              sx={{
                height: laneHeight,
                borderBottom: "1px solid rgba(0,0,0,0.06)",
                position: "relative"
              }}
            />
          ))}

         {/* blocks */}
{blocksFlat.map((b) => {
  const p = placementsById[String(b.id)];
  if (b.phaseName === "Consegna Master") {
  console.log("MASTER UI FIELDS", {
    id: b.id,
    ep: b.episodeNumber,
    start: b.startDate,
    end: b.endDate,
    laneIndex: p?.laneIndex,
    xStart: p?.xStart,
    xEnd: p?.xEnd,
    rangeFrom: safeRange.fromDay,
    rangeTo: safeRange.toDay,
    originISO
  });
}

  if (!p) return null;

  const laneIndex = p.laneIndex ?? 0;
  const yStack = p.yStack ?? 0;
const top = laneIndex * laneHeight + 12 + (yStack * 38);

  const edit = localEdits[String(b.id)];
  let xS = Number(edit?.xStart ?? p.xStart);
let xE = Number(edit?.xEnd ?? p.xEnd);

// fallback robusto se placements sono rotti
if (!Number.isFinite(xS) || !Number.isFinite(xE)) {
  const toISO = (v) => String(v || "").slice(0, 10); // YYYY-MM-DD
  const dayDiffUTC = (fromISO, toISO_) => {
    const a = new Date(fromISO + "T00:00:00Z");
    const b = new Date(toISO_ + "T00:00:00Z");
    const ms = b.getTime() - a.getTime();
    return Math.round(ms / 86400000);
  };

  const sISO = toISO(b.startDate);
  const eISO = toISO(b.endDate);

  if (originISO && /^\d{4}-\d{2}-\d{2}$/.test(sISO)) {
    xS = dayDiffUTC(originISO, sISO);
  }
  if (originISO && /^\d{4}-\d{2}-\d{2}$/.test(eISO)) {
    // end esclusivo: se stesso giorno => +1
    const rawEnd = dayDiffUTC(originISO, eISO);
    xE = rawEnd + 1;
  } else if (Number.isFinite(xS)) {
    xE = xS + 1;
  }
}

// guard finali (evita width NaN / negative)
if (!Number.isFinite(xS) || !Number.isFinite(xE)) return null;
if (xE <= xS) xE = xS + 1;


  const segments = splitIntoWorkingSegments(xS, xE);
if (b.phaseName === "Ingest") {
}
if (b.phaseName === "Consegna Master") {
  console.log("MASTER UI", {
    id: b.id,
    ep: b.episodeNumber,
    start: b.startDate,
    end: b.endDate,
    laneIndex: p?.laneIndex,
    xStart: p?.xStart,
    xEnd: p?.xEnd
  });
}

  return segments.map((seg) => {
    const segLeft = (seg.xS - safeRange.fromDay) * dayWidth;
    const segWidth = Math.max(6, (seg.xE - seg.xS) * dayWidth);

    return (
      <Box
        key={`${b.id}-${seg.xS}-${seg.xE}`}
        title={`${b.phaseName || b.phaseId} • Ep ${b.episodeNumber ?? "?"}`}
        onPointerDown={(e) => beginDrag(e, "move", b.id, xS, xE)} // muovi il blocco intero
        sx={{
          position: "absolute",
          overflow: "hidden",
          transform: "translateZ(0)",
          top,
          left: segLeft,
          width: segWidth,
          height: 34,
         bgcolor: episodeColor(b.episodeId ?? b.episode_id ?? b.episodeNumber ?? b.episode_no ?? b.episode),
          borderRadius: 1.5,
          border:
          b.phaseName === "Montaggio" ? "2px solid rgba(59,130,246,0.85)" :
          b.phaseName === "Visioni" ? "2px solid rgba(245,158,11,0.85)" :
          b.phaseName === "Finalizzazione" ? "2px solid rgba(16,185,129,0.85)" :
          "1px solid rgba(0,0,0,0.10)",
          display: "flex",
          alignItems: "center",
          px: 1,
          cursor: "grab",
          userSelect: "none",
          touchAction: "none",
          boxShadow: "0 2px 4px rgba(0,0,0,0.18)"
        }}
      >
        <Typography variant="caption" noWrap>
  {`Ep.${String(b.episodeNumber ?? "").padStart(2, "0")}`}
</Typography>

        {/* maniglia resize SOLO sull’ultimo segmento */}
        {seg.xE === xE && (
          <Box
            onPointerDown={(e) => beginDrag(e, "resize", b.id, xS, xE)}
            sx={{
              position: "absolute",
              right: 0,
              top: 0,
              width: 12,
              height: "100%",
              cursor: "ew-resize",
              zIndex: 5,
              bgcolor: "rgba(0,0,0,0.15)"
            }}
          />
        )}
      </Box>
    );
  });
})}


        </Box>
      </Box>
    </Box>
    <Snackbar
  open={saveSnack.open}
  autoHideDuration={1400}
  onClose={() => setSaveSnack(s => ({ ...s, open: false }))}
  anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
>
  <Alert
    onClose={() => setSaveSnack(s => ({ ...s, open: false }))}
    severity={saveSnack.severity}
    variant="filled"
    sx={{ width: "100%" }}
  >
    {saveSnack.msg}
  </Alert>
</Snackbar>

  </Box>
);
}